import { render } from "./StepForm.vue?vue&type=template&id=72664943"
import script from "./StepForm.vue?vue&type=script&lang=js"
export * from "./StepForm.vue?vue&type=script&lang=js"

import "./StepForm.vue?vue&type=style&index=0&id=72664943&lang=css"

import exportComponent from "/builds/proximis/page_abonnement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__